/**
 * Shared Tailwind class strings for opportunity/set drag-reorder surfaces
 * (card grids, skeletons, gutter grips).
 */
/** Grid with horizontal bleed for left-gutter grips; `overflow-x-visible` pairs with `min-w-0` ancestors. */
export const OPPORTUNITY_DRAG_REORDER_GRID_CLASS =
  "grid grid-cols-1 gap-4 overflow-x-visible sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4"

/** Keyboard focus ring for drag grips (table row, opportunity card, set card). */
export const OPPORTUNITY_DRAG_GRIP_FOCUS_CLASS =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
